export default {"src":"/_next/static/media/peep-hero.8f8c108c.svg","height":1500,"width":1500};